var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("Calculette.titreFormulaire")))]),_c('calculette-resultat',{attrs:{"resultat":_vm.resultat}}),_c('button',{staticClass:"btn btn-primary submitandwait",attrs:{"type":"submit","name":"next"},on:{"click":_vm.onSubmit}},[_vm._v(" "+_vm._s(_vm.$t("Calculette.buttons.autreSimulation"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }